import { Dollar } from '@tmov/design-system/icons';
import styled from 'styled-components';

export const ContainerLance = styled.div`
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;

  width: 304px;
  height: 68px;
  margin-bottom: 24px;
`;

export const DollarContainer = styled.div`
  min-width: 45px;
  min-height: 45px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background: #f1f4f5;
`;

export const DollarIcon = styled(Dollar)`
  color: #b2bbbf;
`;

export const DescricaoContainer = styled.div`
  height: 100%;
  width: 100%;

  p {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
